<template>
  <el-carousel class="widget-view" :interval="5000" arrow="always" :height="this.$util.num2px(widgetProps.viewProps.height)">
    <el-carousel-item v-for="(item, index) in viewProps.dataConfig.data" :key="index">
      <el-image :src="item[datasourceProps.dataMapping['imgUrl']]" class="img" :fit="widgetProps.viewProps.fitType || 'cover'"/>
    </el-carousel-item>
  </el-carousel>
</template>

<script>
import ApiDesignApi from "@/api/datasvc/apiDesign.api";

export default {
  name: 'WidgetBannerView',
  components: {},
  data() {
    return {}
  },
  props: {
    widgetProps: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    viewProps() {
      return this.widgetProps.viewProps;
    },
    datasourceProps() {
      return this.widgetProps.datasourceProps;
    }
  },
  watch: {
    'widgetProps.datasourceProps': {
      handler: function (val) {
        this.handleFetchData().then(data => this.handleFillData(data)).then(()=>{});
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    this.handleFetchData().then(data => this.handleFillData(data)).then(()=>{});
  },
  methods: {
    /**
     * 获取数据
     */
    handleFetchData() {
      return new Promise((resolve, reject) => {
        console.log("------handleFetchData---------->", JSON.stringify(this.datasourceProps));
        if (this.datasourceProps.datasourceType === 'STATIC') {
          // [{},{}]
          let respData = this.datasourceProps.dataConfig[this.datasourceProps.datasourceType].data;
          resolve(respData);
        } else if (this.datasourceProps.datasourceType === 'API') {
          let dataConfig = this.datasourceProps.dataConfig[this.datasourceProps.datasourceType];
          if (dataConfig && dataConfig.datasource) {
            let reqParams = (typeof dataConfig.reqParams === 'string') ? JSON.parse(dataConfig.reqParams) : dataConfig.reqParams;
            ApiDesignApi.runApi(dataConfig.datasource, reqParams).then(resp => {
              resolve(resp.data);
            });
          } else {
            reject();
          }
        } else {
          reject();
        }
      });
    },
    /**
     * 填充数据
     */
    handleFillData(respData) {
      let dataList = (typeof respData === 'string') ? JSON.parse(respData) : respData;
      this.viewProps.dataConfig.data = dataList;
    },
  }
}

</script>
<style lang="less" scoped>
.widget-view {
  height: 100%;
  width: 100%;

  .img {
    height: 100%;
    width: 100%;
  }
}
</style>
